<ng-template appComponentHost></ng-template>

@for (
  subTreeCategoryWithProduct of treeCategoryWithProduct().children;
  track subTreeCategoryWithProduct.category.id
) {
  <app-category-factory
    [componentClass]="componentClass()"
    [class.category-horizontal-highlight-item]="isHorizontalHighlight()"
    [isHorizontalHighlight]="isHorizontalHighlight()"
    [treeCategoryWithProduct]="subTreeCategoryWithProduct"
    [isOrderingAllowed]="isOrderingAllowed()"
    [categoryNameColor]="categoryNameColor()"
    [categoryDescriptionColor]="categoryDescriptionColor()"
    [highlightCategoryNameColor]="highlightCategoryNameColor()"
    [highlightCategoryBackgroundColor]="highlightCategoryBackgroundColor()"
    [productNameColor]="productNameColor()"
    [productDescriptionColor]="productDescriptionColor()"
    [productPriceColor]="productPriceColor()"
    [productImagePlaceholderColor]="productImagePlaceholderColor()"
    [productBorderColor]="productBorderColor()"
    [productBackgroundColor]="productBackgroundColor()"
    [productHoverColors]="productHoverColors()"
    [tagColors]="tagColors()"
    (navigateTo)="onNavigateTo($event)"
  ></app-category-factory>
}
